import React, { Component } from 'react';
import Button from '../Components/Button.js'
import './JoinRoomPrompt.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayName: ''
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.joinRoom = this.joinRoom.bind(this);
  }

  componentDidMount() {
    this.userNameInput.focus();
  }

  handleChange(event) {
    this.setState({ displayName: event.target.value });
  }

  handleKeyUp(event) {
    if (event.key === 'Enter')
      this.joinRoom();
  }

  joinRoom() {
    if (this.state.displayName)
      this.props.onAddUser(this.state.displayName)
  }

  render() {
    return (
      <div className="prompt-container">
        <div className="prompt">
          <div className="prompt-title">Introduce yourself <span role="img" aria-label="waving hand">👋</span></div>
          <div className="prompt-description">Let people in the room know who you are.</div>
          <input type="text" placeholder="Your name"
            maxLength="15"
            onChange={this.handleChange}
            onKeyUp={this.handleKeyUp}
            ref={(input) => { this.userNameInput = input; }} />
          <Button className="button--green button--full" onClick={this.joinRoom}>Enter Room</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Room/JoinRoomPrompt.js